import { mode } from '@chakra-ui/theme-tools';
const Card = {
	baseStyle: (props: any) => ({
		p: '20px',
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		position: 'relative',
		borderRadius: '20px',
		minWidth: '0px',
		wordWrap: 'break-word',
		bg: mode('#ffffff', 'navy.800')(props),
		boxShadow: mode('0px 4px 12px rgba(0, 0, 0, 0.05)', 'unset')(props),
		border: mode('1px solid', '0px solid')(props),
		borderColor: mode('secondaryGray.300', 'transparent')(props),
		backgroundClip: 'border-box'
	})
};

export const CardComponent = {
	components: {
		Card
	}
};
